<section class="bg-black text-white pt-32 pb-16 px-8 md:px-16">
  <div class="max-w-6xl mx-auto">
    <app-navigate-back class="mb-4"></app-navigate-back>
    <h1 class="text-4xl md:text-5xl font-black mb-4">About <span class="text-varroc-accent">Us</span></h1>
    <p class="text-gray-400 text-2xl">Take control of your drive with our industry-leading connected vehicle platform.</p>
  </div>
</section>

<section class="bg-black px-8 md:px-16 pb-24">
  <div class="max-w-6xl mx-auto">
    <p class="text-gray-300 text-lg leading-relaxed">
      Since 2013, Varroc Connect has been providing a mature connected vehicle platform that connects your vehicle to the cloud
      and provides connectivity features, such as remote monitoring and various vehicle diagnostics.
    </p>
    <p class="text-gray-400 text-base leading-relaxed mt-6">
      We also offer a user-friendly smartphone App and web interface for monitoring the vehicle and accessing driving insights.
      Through meticulous development, we integrated advanced algorithms and APIs, ensuring optimal performance of our platform.
    </p>
    <p class="text-gray-400 text-base leading-relaxed mt-6">
      We aim to enhance drivers' lives by offering exceptional driving experiences and entertainment, prioritizing safety,
      and offering a fully developed connected platform. We prioritize the vehicle user's safety with advanced features
      and real-time updates. With our commitment to excellence, we strive not only to meet your needs but exceed them.
    </p>
  </div>
</section>